import React from "react";
import "./Counter.css";

const Counter = () => {
  return (
    <>
<section className="counter_section">
  <div className="container">
    <div className="counter-bg">

      <div className="row rowwidth">
        <div className="col-lg-3 col-sm-6 col-6">
          <div className="counter-box bd-right">
            <h2 className="number">10000+</h2>
            <p className="text">Farmers</p>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 col-6">
          <div className="counter-box bd-right">
            <h2 className="number">500+</h2>
            <p className="text">Dealers</p>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 col-6">
          <div className="counter-box bd-right">
            <h2 className="number">50+</h2>
            <p className="text">Products</p>
          </div>
        </div>
          <div className="col-lg-3 col-sm-6 col-6">
          <div className="counter-box">
            <h2 className="number">200+</h2>
            <p className="text">Reviews</p>
          </div>
        </div>
      </div>

      <div className="counter-divider"></div>

      <div className="counter_states">
        <span>Maharashtra</span>
        <span>Karnataka</span>
        <span>Madhya Pradesh</span>
      </div>

    </div>
  </div>
</section>
    </>
  );
};

export default Counter;
